import { cn } from 'utils/cn';

const iconTypesAndCodes = {
	account_balance_wallet: 'e850',
	add_a_photo: 'e439',
	add_photo_alternate: 'e43e',
	apps: 'e5c3',
	arrow_back: 'e5c4',
	arrow_back_ios: 'e5e0',
	arrow_forward_ios: 'e5e1',
	arrow_keyboard_down: 'e313',
	arrow_top_right: 'f72d',
	arrow_upward: 'e5d8',
	autorenew: 'e863',
	bookmark_add: 'e598',
	bookmarks: 'e98b',
	brand_awareness: 'e98e',
	calendar_month: 'ebcc',
	call: 'e0b0',
	campaign: 'ef49',
	check: 'e5ca',
	check_circle: 'e86c',
	close: 'e5cd',
	cycle: 'f854',
	delete: 'e872',
	distance: 'f6ea',
	edit: 'e3c9',
	error: 'e000',
	flag: 'e153',
	flag_check: 'f3d8',
	forward_to_inbox: 'f187',
	gpp_bad: 'f012',
	help: 'e887',
	history: 'e889',
	hotel_class: 'e743',
	hourglass: 'ebff',
	hourglass_bottom: 'ea5c',
	hourglass_top: 'ea5b',
	info: 'e88e',
	ios_share: 'e6b8',
	keyboard_arrow_down: 'e313',
	keyboard_arrow_left: 'e314',
	keyboard_arrow_right: 'e315',
	keyboard_arrow_up: 'e316',
	lightbulb: 'e0f0',
	link: 'e157',
	lists: 'e9b9',
	local_mall: 'e54c',
	location_on: 'e0c8',
	mail: 'e158',
	more_horiz: 'e5d3',
	no_photography: 'f1a8',
	outgoing_mail: 'f0d2',
	payments: 'ef63',
	pets: 'e91d',
	phone_iphone: 'e325',
	photo_camera: 'e412',
	play_circle: 'e1c4',
	radar: 'f04e',
	radio_button_checked: 'e837',
	radio_button_unchecked: 'e836',
	redeem: 'e8b1',
	rotate_right: 'e41a',
	search: 'e8b6',
	shield_locked: 'f592',
	shoppingmode: 'efb7',
	star: 'e838',
	star_half: 'e839',
	stream_apps: 'f79f',
	stylus: 'f604',
	thumb_up: 'e8dc',
	tune: 'e429',
	visibility: 'e8f4',
	visibility_off: 'e8f5',
	warning: 'e002',
	window: 'f088',
} as const;

export type IconType = keyof typeof iconTypesAndCodes;

export function getIconNames() {
	return Object.keys(iconTypesAndCodes).sort().join(',');
}

interface Props {
	/**
	 * Symbol type is listed on https://fonts.google.com/icons?icon.size=24&icon.color=%23e8eaed&icon.platform=web&icon.set=Material+Symbols
	 */
	type: IconType;
	fill?: boolean;
	/**
	 * Size in pixels
	 */
	size?: number;
	className?: string;
	title?: string;
}

export function Icon({ className, fill, type, size, title }: Props) {
	// Validate icon type to prevent XSS attacks
	const isValidIconType = type && type in iconTypesAndCodes;
	const safeIconCode = isValidIconType ? iconTypesAndCodes[type] : iconTypesAndCodes.error;

	return (
		<span
			style={size ? { fontSize: `${size}px`, width: `${size}px`, height: `${size}px` } : {}}
			class={cn(
				`icon inline-block material-symbols-outlined select-none !leading-none`,
				fill && 'icon-fill',
				className,
			)}
			title={title}
			dangerouslySetInnerHTML={{ __html: `&#x${safeIconCode};` }}
		/>
	);
}
